import { useEffect } from "react";
import { EventParams, EventsKeys, UseEventProps, eventEmitter } from "./types";

export type GetEventParamsType<T extends EventsKeys> =
  T extends keyof EventParams ? EventParams[T] : never;

/**
 * Issue an event with argument typing check.
 * @param eventName
 * @param args
 * @returns
 */
export function emitEvent<T extends EventsKeys>(
  eventName: T,
  args?: GetEventParamsType<T>
) {
  return eventEmitter.emit(eventName, args);
}


export function useEvent<T extends EventsKeys>({
    eventName,
    callback,
}: UseEventProps<T>) {
    useEffect(() => {
        eventEmitter.on(eventName, callback);

        return () => {
            eventEmitter.off(eventName, callback);
        };
    }, [eventName, callback]);
}